<template>
  <div class="welcome-page">
    <div v-if="loading" class="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center z-50">
      <div class="spinner"></div>
    </div>

    <div v-if="user && user.role!='Student'"> 
      <div class="mx-auto" style="margin-top: 20px;">
        <h1 class="text-2xl font-bold text-primary mb-6">
          Welcome, {{ user ? user.name : "" }} 
        </h1>

        <div class="bg-gray-100 shadow-lg rounded-lg overflow-hidden mb-8">
          <!--<div class="bg-gray-100 text-white p-4">
            <h2 class="text-xl font-semibold text-black">Introduction</h2>
          </div>
          <hr style="color: black;">-->
          <div class="text-left py-4 bg-gray-100 px-8 rounded-lg" style="font-size: 16px;" v-html="formatedIntroduction">
          </div>
        </div>

       <!-- <div class="bg-white shadow-lg rounded-lg overflow-hidden mb-8">
          <div class="bg-primary text-white p-4">
            <h2 class="text-xl font-semibold">Quick Start Guide</h2>
          </div>
          <div class="text-left py-4 bg-white px-8 rounded-lg" v-html="settings.guide"></div>
        </div>-->
      </div>
      <!-- <div class="text-center">
            <router-link to="/dashboard" class="inline-block bg-primary text-white px-6 py-3 rounded-md hover:bg-primary-light transition duration-300 transform hover:scale-105">
              Get Started
            </router-link>
          </div>-->
    </div>
    <div v-else>
      <StudentHomePage />
    </div>
  </div>

</template>

<script>
import StudentHomePage from "@/views/StudentHomePage.vue";
import { mapState } from "vuex";
export default {
  name: "WelcomePage",
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
    formatedIntroduction() {
      return this.settings ? this.settings.introduction.replaceAll('<h3>', '<div class="h3t">').replaceAll('</h3>', '</div>').replaceAll('<h2>', '<div class="h2t">').replaceAll('</h2>', '</div>').replaceAll('<h1>', '<div class="h1t">').replaceAll('</h1>', '</div>') : "";
    }
  },
  components: {
    StudentHomePage,
  },
  
  data() {
    return {
      settings: {
        introduction: "",
        guide: "",
      },
      loading: false,
    };
  },
  async mounted() {
    this.loading = true;
    if (!this.$store.state.settings)
      await this.$store.dispatch('fetchInstitutionSettings');
    this.settings = this.$store.state.settings;
    this.loading = false;
  },
};
</script>
<style>
.h3t {
  font-size: 18px !important;
}
.h2t {
  font-size: 24px !important;
}
.h1t {
  font-size: 30px !important;
}
</style>